import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const athleteApi = createApi({
  reducerPath: 'athletes',
  tagTypes: ['Athlete'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchAthletes: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Athlete', id: 'LIST' },
                ...result.map((r) => ({ type: 'Athlete', id: r.id })),
              ]
            : [{ type: 'Athlete', id: 'LIST' }],
        // El token se inyecta automáticamente por el baseQuery compartido (prepareHeaders)
        query: ({ coach }) => ({
          url: `?resource=athlete&coach=eq.${coach}&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      createAthlete: builder.mutation({
        invalidatesTags: [{ type: 'Athlete', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=athlete`,
          method: 'POST',
          body: data,
        }),
      }),

      updateAthlete: builder.mutation({
        invalidatesTags: (result, error, { id: athleteId }) => [
          { type: 'Athlete', id: athleteId },
          { type: 'Athlete', id: 'LIST' },
        ],
        query: ({ id: athleteId, submitData }) => ({
          url: `?resource=athlete&id=eq.${athleteId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchAthlete: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Athlete', id: arg }],
        query: (athleteId) => ({
          url: `?resource=athlete&id=eq.${athleteId}`,
          method: 'GET',
        }),
      }),

      fetchAthleteByNativeUserId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Athlete', id: 'LIST' },
                ...result.map((r) => ({ type: 'Athlete', id: r.id })),
              ]
            : [{ type: 'Athlete', id: 'LIST' }],
        query: (userId) => ({
          url: `?resource=athlete&native_user=eq.${userId}`,
          method: 'GET',
        }),
      }),

      fetchAthleteJournalByNativeUserId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Athlete', id: 'LIST' },
                ...result.map((r) => ({ type: 'Athlete', id: r.id })),
              ]
            : [{ type: 'Athlete', id: 'LIST' }],
        query: (userId) => ({
          url: `?resource=athlete&native_user=eq.${userId}&select=*,journal(*)`,
          method: 'GET',
        }),
      }),
    };
  }
});

export const {
  useFetchAthletesQuery,
  useCreateAthleteMutation,
  useUpdateAthleteMutation,
  useFetchAthleteQuery,
  useFetchAthleteByNativeUserIdQuery,
  useLazyFetchAthleteByNativeUserIdQuery,
  useFetchAthleteJournalByNativeUserIdQuery
} = athleteApi;

export { athleteApi };
